import type { OperationModalProps } from '@atlassian/jira-directory-base/src/model/index.tsx';
import EditModal from '@atlassian/jira-edit-filters-modal/src/index.tsx';
import {
	componentWithCondition,
	functionWithCondition,
} from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import type { Filter } from '@atlassian/jira-filters-common/src/model/index.tsx';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { AsyncUpdateFilterDialog as UpdateFilterDialog } from '@atlassian/jira-save-filter-dialog/src/ui/update-filter-dialog/async.tsx';
import type { OperationData } from '@atlassian/jira-shareable-entity-dialog/src/model/types.tsx';
import { getBaseUrl } from '../../../state/selectors/app/index.tsx';
import {
	getName,
	getDescription,
	getEdits,
	getShares,
} from '../../../state/selectors/filters/index.tsx';
import type { State } from '../../../state/types.tsx';

const mapStateToPropsOld = (state: State, ownProps: OperationModalProps<Filter>) => ({
	baseUrl: getBaseUrl(state),
	id: ownProps.entityId,
	name: getName(state, ownProps.entityId),
	description: getDescription(state, ownProps.entityId),
	// owner: getOwner(state, ownProps.entityId), // send only when backend supports changing owner
	sharePermissions: getShares(state, ownProps.entityId),
	editPermissions: getEdits(state, ownProps.entityId),
	onCancel: ownProps.onCancel,
	onInitiateSuccess: () => {
		ownProps.onDialogShown();
	},
	// onEditFailed: noop, // do NOT send .onUpdateFailed() - it will remove operation from `operations` array, even though modal is still open
	onEdited: (_updatedData: OperationData) => {
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
		ownProps.onUpdated();
	},
});

const mapStateToPropsNew = (initialState: State, ownProps: OperationModalProps<Filter>) => {
	const onEdited = (_updatedData: OperationData) => {
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
		ownProps.onUpdated();
	};
	const onInitiateSuccess = () => {
		ownProps.onDialogShown();
	};

	return (state: State) => ({
		baseUrl: getBaseUrl(state),
		id: ownProps.entityId,
		name: getName(state, ownProps.entityId),
		description: getDescription(state, ownProps.entityId),
		sharePermissions: getShares(state, ownProps.entityId),
		editPermissions: getEdits(state, ownProps.entityId),
		onCancel: ownProps.onCancel,
		onInitiateSuccess,
		// onEditFailed: noop, // do NOT send .onUpdateFailed() - it will remove operation from `operations` array, even though modal is still open
		onEdited,
	});
};

const mapStateToPropsNewModal = (initialState: State, ownProps: OperationModalProps<Filter>) => {
	const onEdited = (_updatedData: OperationData) => {
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
		ownProps.onUpdated();
	};

	return () => ({
		onDialogShown: ownProps.onDialogShown,
		filterId: ownProps.entityId,
		onClose: ownProps.onCancel,
		onSuccess: onEdited,
		// onEditFailed: noop, // do NOT send .onUpdateFailed() - it will remove operation from `operations` array, even though modal is still open
		isOpen: true,
	});
};

const FilterDialog = componentWithCondition(getWillShowNav4, UpdateFilterDialog, EditModal);
const mapStateToProps = functionWithCondition(
	() => fg('fix_unstable_selector_in_filter_directory'),
	// @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
	functionWithCondition(getWillShowNav4, mapStateToPropsNewModal, mapStateToPropsNew),
	// @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
	mapStateToPropsOld,
);

export default connect(mapStateToProps, {})(FilterDialog);
